/** @format */

import React from 'react';
import tw from 'twin.macro';
import '../form.css';
import { PrimaryAction } from './hero/BackgroundAsImage';
import { SectionHeading, Subheading } from './misc/Headings';
const Subheadingnew = tw(Subheading)`
text-gray-600 font-normal text-center sm:w-6/12 mx-auto px-2
`;

const Contactbtn = tw(PrimaryAction)` sm:px-8 sm:py-4 text-base absolute `;
const contactform = () => {
	return (
		<form id="form">
			<SectionHeading style={{ marginTop: '20px' }}>Contact us to Fix your Credit</SectionHeading>
			<Subheadingnew style={{ marginTop: '20px' }}>
				Give us your name and email address and we will get back to you to fix your credit
			</Subheadingnew>
			<div className="form-inputs">
				<div className="name-input">
					<label htmlFor="firstname"></label>
					<input type="text" id="firstname" placeholder="First Name" className="input" />
					<label htmlFor="lastname"></label>
					<input type="text" id="lastname" placeholder="Last Name" className="input" />
				</div>
				<div className="email-container">
					<label htmlFor="email"></label>
					<input
						type="email"
						name="email"
						id="email"
						placeholder="Enter your email address"
						className="input"
					/>
					<Contactbtn className="form-contactbtn">Contact us</Contactbtn>
				</div>
				{/* <div className="btn-center">
					<Contactbtn>Contact us</Contactbtn>
				</div> */}
			</div>
		</form>
	);
};
export default contactform;
